import type { Database } from '@shkola/db-types';
import type { SupabaseClient } from '@supabase/supabase-js';
import { type ReactNode, createContext, createElement, useContext } from 'react';

export type Db = SupabaseClient<Database>;

const DbContext = createContext<Db | null>(null);

/** Makes the signed-in Supabase client available to every data hook below it. */
export function DbProvider({ client, children }: { client: Db; children: ReactNode }) {
  return createElement(DbContext.Provider, { value: client }, children);
}

export function useDb(): Db {
  const db = useContext(DbContext);
  if (!db) throw new Error('useDb must be used inside <DbProvider>');
  return db;
}

/** Throws the Supabase error so TanStack Query treats it as a failed query. */
export function must<T>(result: { data: T | null; error: unknown }): T {
  if (result.error) throw result.error;
  return result.data as T;
}
